import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IListaGrid } from '../IListaLeads';

@Component({
  selector: 'app-leads-detalhe',
  templateUrl: './leads-detalhe.component.html',
  styleUrls: ['./leads-detalhe.component.scss']
})
export class LeadsDetalheComponent implements OnInit {

  constructor() { }

  @Input() visible: boolean = true;
  @Input() leadGrid: IListaGrid;
  @Input() dadosHistorico: any[];
  @Input() dadosUsadoNaTroca: any[];
  @Output() fecharModalDetalhe: EventEmitter<boolean> = new EventEmitter<boolean>();
  cols: any[];
  colsUsado: any[];
  detalhe: any;
  displayBasic: boolean = false;

  ngOnInit() {
    this.cols = [
      { field: 'dtContato', header: 'Data/Hora Contato' },
      { field: 'tipoContato', header: 'Tipo Contato' },
      { field: 'datalhe', header: 'Detalhe do Andamento' }
    ];

    this.colsUsado = [
      { field: 'descVeicTroca', header: 'Usado na Troca' },
      { field: 'chassiVeicTroca', header: 'Chassi' },
      { field: 'valorUnitVeicTroca', header: 'Valor da Avaliação' }
    ];
  }

  hideDialog() {
    this.visible = false;
    this.fecharModalDetalhe.emit(this.visible);
    this.fechar();
  }

  public abrirDetalhe(dado: any) {
    this.displayBasic = true
    this.detalhe = dado.detalhe;
  }

  public fechar() {
    this.displayBasic = false
  }

}